// Angular
import { Component, OnInit, Input } from "@angular/core";
// Services
import { ElasticService } from "../../../services/elastic";
// External
import * as lodash from "lodash";
import { ApiService } from "../../../services/api";
import { FormsService } from "./../../../services/forms";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ElementRef, NgZone, ViewChild } from "@angular/core";
import {} from "googlemaps";
import { AngularFireAuth } from "angularfire2/auth";

import { MapsAPILoader } from "@agm/core";
import { async } from "@angular/core/testing";

@Component({
  selector: "app-society",
  templateUrl: "./society.component.html",
})
export class SocietyComponent implements OnInit {
  @Input() public temp;
  public form: FormGroup;
  public offerList: Array<any>;
  public society: any;
  public imageLoader = true;
  public address: string;
  public disabled: boolean;
  public avatarLoading: boolean;
  public coverLoading: boolean;
  public currentPage: number;
  public query: string;
  public pageSize: number;
  public zoom: number;
  public isEmailExist = false;
  public insights: Array<any>;
  public isInsightSelect = false;
  public latitude: number;
  public longitude: number;
  public users: Array<any>;
  public maxPage: number;
  private typingDelay: any;
  public isSubmit: boolean = false;

  @ViewChild("search")
  public searchElementRef: ElementRef;
  constructor(
    private elasticService: ElasticService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    public formsService: FormsService,
    private fireAuth: AngularFireAuth,

    private apiService: ApiService
  ) {
    this.currentPage = 0;
    this.pageSize = 40;
    this.query = "";
    this.form = new FormGroup({
      name: new FormControl("", Validators.required),
      email: new FormControl("", Validators.email),
      username: new FormControl("", Validators.required),
      phone: new FormControl(""),
      password: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      confirm: new FormControl(""),
      address: new FormControl(""),
      state: new FormControl(""),
      country: new FormControl(""),
      postCode: new FormControl(""),
      city: new FormControl(""),
    });
    this.form.controls["username"].valueChanges.subscribe((value) => {
      var status = /^\S*$/.test(value);
      if (status) {
        this.username(value);
      } else {
        this.form.controls["username"].patchValue(String(value).trim());
      }
    });

    this.form.controls["email"].valueChanges.subscribe((value) => {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(value).toLowerCase().trim())) {
        this.checkEmail(value);
      }
    });
    this.apiService.list("master/society-insights").then((res) => {
      this.insights = [];
      if (res && res.length > 0) {
        for (let i = 0; i < res.length; i++) {
          let element = res[i];

          element.isSelected = false;
          if (element.status == 1) this.insights.push(element);
        }
      }
    });
  }

  generatePwd() {
    this.form.controls.password.setValue(
      this.form.value.username + "@" + new Date().getFullYear()
    );
    this.form.controls.email.setValue(
      this.form.value.username + "@golfhubber.com"
    );
  }

  ngOnInit() {
    this.goToPage(this.currentPage);
    this.zoom = 4;
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          const results = place.address_components;

          this.form.patchValue({ address: place.formatted_address });

          this.form.controls["postCode"].patchValue(
            this.findResult(results, "postal_code")
          );
          this.form.controls["state"].patchValue(
            this.findResult(results, "administrative_area_level_1")
          );
          this.form.controls["country"].patchValue(
            this.findResult(results, "country")
          );

          this.form.controls["city"].patchValue(
            this.findResult(results, "administrative_area_level_2")
          );
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          console.log(this.form.value);

          this.zoom = 12;
        });
      });
    });
  }

  goToPage(index: number) {
    const fromIndex = index * this.pageSize;
    var queryParams = {};
    if(!this.query)
    {
      queryParams = {
        index: "users",
        type: "society",
        size: this.pageSize,
        from: fromIndex,
        "body/query/bool/must/query_string/query": `${this.query}*`,
        "body/query/bool/must/query_string/fields": [`name`],
        "body/sort/registerDate/order": `desc`,
      };
    }
    else{
      queryParams = {
        index: "users",
        type: "society",
        size: this.pageSize,
        from: fromIndex,
        "body/query/bool/must/match_phrase_prefix/name": `*${this.query.trim().toLowerCase()}*`,
        // "body/query/bool/must/query_string/fields": [`name`],
        "body/sort/registerDate/order": `desc`,
      };
    }
    console.log(queryParams);

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        // console.log(result);

        lodash.forEach(result["hits"], async (item, key) => {
          // console.log(item)
          let com = item["_source"];
          com.status = com.status == undefined ? 1 : com.status;
          // if (this.temp != undefined) {
          //   if (com.isVerified == true && com.status == 1) {
          //     this.users.push(lodash.assign({ id: item["_id"] }, com));
          //   }
          // } else {
          this.users.push(lodash.assign({ id: item["_id"] }, com));
          // }
        });

        window.scrollTo(0, 0);
        this.imageLoader = false;
        this.currentPage = index;
        this.maxPage = Math.ceil(result["total"] / this.pageSize);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  public findResult = function (results, name) {
    const result = lodash.find(results, function (obj) {
      return obj.types[0] === name;
    });
    return result ? result.long_name : null;
  };

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(this.currentPage);
    }, 400);
  }

  // async unVerfied(item) {
  //   if (confirm("Are you sure,you want to unverify the Society?")) {
  //     try {
  //       await this.apiService.set(`/users/${item.id}/isVerified`, false);
  //       await this.apiService.set(
  //         `/user-profiles/${item.uid}/${item.id}/isVerified`,
  //         false
  //       );
  //     } catch (error) {
  //       console.log(error);
  //     }

  //     item.isVerified = null;
  //   }
  // }
  async verified(item) {
    if (confirm("Are you sure,you want to verify the Society?")) {
      try {
        await this.apiService.set(`/users/${item.id}/isVerified`, true);
        await this.apiService.set(`/user-profiles/${item.uid}/${item.id}`, {
          type: 6,
          role: 1,
          isVerified: true,
        });
        item.isVerified = true;
      } catch (error) {
        console.log(error);
      }
    }
  }

  async activate(item) {
    if (confirm("Are you sure,you want to activate the Society?")) {
      try {
        await this.apiService.set(`/users/${item.id}/status`, 1);
        await this.apiService.set(
          `/user-profiles/${item.uid}/${item.id}/status`,
          1
        );
        this.apiService.set(
          `server-process/active-deactive-stats/${item.id}/1`,
          true
        );
        item.status = 1;
      } catch (error) {
        console.log(error);
      }
    }
  }

  async deactivate(item) {
    if (confirm("Are you sure,you want to deactivate the Society?")) {
      try {
        await this.apiService.set(`/users/${item.id}/status`, 2);
        await this.apiService.set(
          `/user-profiles/${item.uid}/${item.id}/status`,
          2
        );
        this.apiService.set(
          `server-process/active-deactive-stats/${item.id}/2`,
          true
        );
      } catch (error) {
        console.log(error);
      }
      item.status = 2;
    }
  }
  username(value: string) {
    if (!value) {
      const errors = this.form.controls["username"].errors;
      if (errors) {
        delete errors.used;
        this.form.controls["username"].setErrors(errors);
      }
      return;
    }

    this.apiService
      .list("/index/users", {
        query: {
          orderByValue: true,
          equalTo: this.form.controls["username"].value.toLowerCase(),
        },
      })
      .then(
        (result) => {
          if (result.length) {
            this.form.controls["username"].setErrors({ used: true });
          } else {
            const errors = this.form.controls["username"].errors;
            if (errors) {
              delete errors.used;
              this.form.controls["username"].setErrors(errors);
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }
  confirm() {
    const password = this.form.controls["password"].value;
    const confirm = this.form.controls["confirm"].value;

    if (password !== confirm) {
      this.form.controls["confirm"].setErrors({ confirm: true });
    } else {
      this.form.controls["confirm"].setErrors(null);
    }
  }

  checkEmail(value) {
    console.log(this.form.controls["password"].errors);

    this.fireAuth.auth.fetchProvidersForEmail(value).then((result) => {
      if (result.length) {
        this.isEmailExist = true;
      } else {
        this.isEmailExist = false;
      }
    });
  }
  submit() {
    this.imageLoader = true;
    this.isSubmit = true;
    // var insightObj = {}
    // let count = 0
    // for (let i = 0; i < this.insights.length; i++) {
    //   const element = this.insights[i];

    //   if (element.isSelected) {
    //     insightObj[element.$key] = 1
    //     ++count;
    //   }

    // }

    // if (count == 0) { this.isInsightSelect = true }
    // else { this.isInsightSelect = false }

    // if (this.isInsightSelect) return
    let obj = {
      registerDate: parseInt(new Date().getTime() / 1000 + ""),
      email: this.form.value.email,
      username: this.form.value.username.toLowerCase(),
      name: this.form.value.name,
      type: 6,
      status: 2,
      password: this.form.value.password,
      //phone: this.form.value.phone + "",
      updatedAt: new Date().getTime() / 1000,
      // insights: insightObj,
      private: 1,
      role: 1,
      // city: this.form.value.city ? this.form.value.city : "",
      // state: this.form.value.state ? this.form.value.state : "",
      // country: this.form.value.country ? this.form.value.country : "",
      // address: this.form.value.address ? this.form.value.address : "",
      // location: {
      //   lat: this.latitude ? this.latitude : "",
      //   lon: this.longitude ? this.longitude : "",
      // },
      // postCode: this.form.value.postCode,
      isVerified: false,
    };

    if (this.form.valid) {
      let key = this.apiService.getKey("users");

      this.apiService
        .set(`/server-process/create-user/${key}`, obj)
        .then(() => {
          location.reload();
        })

        .catch((error) => {
          console.error(error);
          alert(error.message);
        });
    }
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }
}
